import React, { useEffect } from 'react';
import clearError from '../../../../utilities/authentication/authenticationSlice';
import useExtendedEffect from '../../../../utilities/hooks/useExtendedEffect';
import useEffectAsync from '../../../../utilities/hooks/useEffectAsync';
import { connect } from 'react-redux';
import {
  goToPage,
  setFlowType,
  setSaleDetails,
  reportAnalytics,
  redirectToLogin,
  setLoginData,
  setSelectedInternetPackage,
  saveBaseBezeqFiberProduct,
  setError,
  createOtpForNewCustomerAsync,
  checkUserAsync
} from '../saleBlockSlice';
import { showAppLoader, hideAppLoader } from '../../../Shared/Loader/LoaderSlice';
import ProviderManager from '../../../../provider/providerManager';
import { getRecaptchaToken } from '../../../../utilities/recaptcha/recaptcha';

const LoginPage = (props) => {
  useEffectAsync(async () => {
    var storage = window.localStorage || window.sessionStorage;
    var previousPage = storage.getItem('previousPage');

    //----------------- after login -----------------
    if (previousPage == 'loginSuccess') {
      if (props._authentication.loginData.isFullAuthenticated) {
        //clearError(); // clear 403 error in storage to prevent slow typing and performance problem
        let saleDetails = {};

        const id = props._authentication?.loginData?.userDetails?.IDNumber;
        const firstName = props._authentication?.loginData?.userDetails?.firstName;
        const lastName = props._authentication?.loginData?.userDetails?.lastName;
        const contactNumber = props._authentication?.loginData?.userDetails?.contactNumber;
        props.setLoginData({ id: id, firstName: firstName, lastName, contactNumber: contactNumber });

        if (props.saleType != 'cellular') {
          saleDetails = await getSaleDetails();
          props.setSaleDetails(saleDetails);

          if (saleDetails?.isJetCustomer) {
            props.setError({ isDisplay: true, id: 64, isOpenWorkOrder: true });
            return;
          }
        }

        await props.checkUserAsync();

        switch (props.saleType) {
          case 'tv':
            props.goToPage({ page: 'productsPage', percent: 11 });
            break;
          case 'cellular':
            props.goToPage({ page: 'chooseNumberPage', percent: 14 });
            break;
          case 'internet':
            getNextPage(saleDetails);
            break;
        }
      }
      return;
    }
    //----------------- after login -----------------

    //--------------- back from login ---------------
    if (previousPage == 'login') {
      switch (props.saleType) {
        case 'tv':
          props.goToPage({ page: 'welcomePage', percent: 0 });
          break;
        case 'app':
          props.goToPage({ page: 'welcomePage', percent: 0 });
          break;
        case 'cellular':
          props.goToPage({ page: 'welcomePage', percent: 0 });
          break;
        case 'internet':
          props.goToPage({ page: 'addressFormPage', percent: 0 });
          break;
      }
      return;
    }
    //--------------- back from login ---------------

    //------------------- forward -------------------
    if (previousPage == 'welcomePage' || previousPage == 'addressFormPage' || previousPage == '') {
      if (props._authentication.loginData.isFullAuthenticated) {
        //clearError(); // clear 403 error in storage to prevent slow typing and performance problem
        let saleDetails = {};

        const id = props._authentication.loginData.userDetails.IDNumber;
        const firstName = props._authentication.loginData.userDetails.firstName;
        const lastName = props._authentication.loginData.userDetails.lastName;
        const contactNumber = props._authentication.loginData.userDetails.contactNumber;
        props.setLoginData({ id: id, firstName: firstName, lastName, contactNumber: contactNumber });


        if (props.saleType != 'cellular') {
          saleDetails = await getSaleDetails();
          props.setSaleDetails(saleDetails);

          if (saleDetails?.isJetCustomer) {
            props.setError({ isDisplay: true, id: 64, isOpenWorkOrder: true });
            return;
          }
        }

        await props.checkUserAsync();

        switch (props.saleType) {
          case 'tv':
            props.goToPage({ page: 'productsPage', percent: 11 });
            break;
          case 'cellular':
            props.goToPage({ page: 'chooseNumberPage', percent: 14 });
            break;
          case 'internet':
            getNextPage(saleDetails);
            break;
        }
      } else {
        storage.setItem('previousPage', 'login');
        const returnUrl = encodeURIComponent(window.location.pathname + window.location.hash.toLowerCase());
        let cancelUrl = '';
        if (props.saleType != 'internet') {
          cancelUrl = encodeURIComponent(window.location.pathname + window.location.hash.toLowerCase() + '?cancel=1');
        }
        //props.hideAppLoader();
        props.redirectToLogin({ returnUrl: returnUrl, cancelUrl: cancelUrl, template: props.loginTemplate });
      }
      return;
    }
    //------------------- forward -------------------

    //--------------------- back --------------------
    if (
      previousPage == 'productsPage' ||
      previousPage == 'chooseNumberPage' ||
      previousPage == 'isIbcInternetCustomerPage' ||
      previousPage == 'internetPackagesPage' ||
      previousPage == 'fiberUpgradesPage' ||
      previousPage == 'technicianPage'
    ) {
      switch (props.saleType) {
        case 'tv':
          props.goToPage({ page: 'welcomePage', percent: 0 });
          break;
        case 'app':
          props.goToPage({ page: 'welcomePage', percent: 0 });
          break;
        case 'cellular':
          props.goToPage({ page: 'welcomePage', percent: 0 });
          break;
        case 'internet':
          props.goToPage({ page: 'addressFormPage', percent: 0 });
          break;
      }
      return;
    }
    //--------------------- back --------------------

    async function getSaleDetails() {
      const recaptchaToken = await getRecaptchaToken('LoginPage');
      if (recaptchaToken == undefined || recaptchaToken == null || recaptchaToken == '') {
        return;
      }

      try {
        const res = await ProviderManager.getProviderData('getSaleDetailsAuth', [props.saleType, recaptchaToken]);
        console.info('getSaleDetailsAuth', res);
        return res?.Body;
      } catch (error) {
        return null;
      }
    }

  }, [props.saleType, props._authentication.loginData.isFullAuthenticated]);

  var storage = window.localStorage || window.sessionStorage;
  var urlVariables;
  try {
    urlVariables = JSON.parse(storage.getItem('urlVariables'));
  } catch (e) { }

  if (urlVariables) {
    if (urlVariables.cancel == '1') {
      props.setFlowType({ flowType: 'newCustomer' });
      switch (props.saleType) {
        case 'tv':
          props.goToPage({ page: 'productsPage', percent: 9 });
          break;
        case 'cellular':
          props.goToPage({ page: 'chooseNumberPage', percent: 10 });
          break;
        case 'internet':
          props.goToPage({ page: 'otpVerifyPhone', percent: 20 });
          break;
      }
      storage.setItem('previousPage', 'cancel');
      storage.setItem('urlVariables', '');
      return null;
    }
    if (urlVariables.newcustomer == '1') {
      props.createOtpForNewCustomerAsync(urlVariables);
      storage.setItem('previousPage', 'newcustomer');
      storage.setItem('urlVariables', '');
    }
  }

  //props.hideAppLoader();

  return (
    <div className='loader'>
      <div className='overlay'></div>
      <div className='spinner-container'>
        <div>
          <div className='spinner'>
            <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 34 34'>
              <g fill='none' fillRule='evenodd'>
                <g fill='var(--theme-primary, #810ea9)' fillRule='nonzero'>
                  <path d='M29.4 12.4c-.08-.32-.2-.68-.32-1-.12-.36-.28-.64-.4-.92s-.24-.52-.4-.76c.12.2.2.44.32.68.08.28.24.6.32.92.08.32.2.68.32 1 .32 1.4.52 3 .32 4.8-.16 1.72-.72 3.6-1.68 5.36-.96 1.68-2.36 3.28-4.2 4.48-.44.28-.88.6-1.36.8-.2.08-.48.24-.72.32-.24.08-.52.2-.76.32-1.04.4-2.12.68-3.24.72l-.44.04-.44.04h-.84c-.56-.04-1.16-.04-1.68-.2-.56-.04-1.12-.24-1.64-.32-.56-.2-1.08-.36-1.56-.6s-.96-.48-1.48-.76c-.24-.12-.48-.28-.68-.44l-.32-.24c-.12-.04-.24-.16-.32-.24l-.32-.24-.16-.16-.08-.08-.04-.04-.04-.04-.6-.6c-.48-.4-.76-.84-1.08-1.24-.16-.16-.28-.44-.44-.68L5 22.64l-.36-.72c-.08-.2-.24-.48-.32-.72-.16-.48-.4-.96-.48-1.48-.08-.24-.16-.48-.2-.76l-.12-.72c-.12-.48-.12-.96-.16-1.48-.04-.48 0-1 .04-1.48.08-.48.12-.96.24-1.4.04-.24.12-.44.16-.68l.04-.32.12-.32c.6-1.72 1.52-3.2 2.6-4.4.32-.32.56-.6.84-.84.36-.36.56-.52.88-.72.56-.48 1.16-.8 1.72-1.12 1.12-.6 2.2-.92 3.08-1.12.88-.2 1.6-.28 2.08-.24.24-.04.44 0 .56 0h.2c1.08.04 2-.88 2-2 .04-1.08-.88-2-2-2h-.12s-.08.04-.24.04c-.16 0-.4 0-.72.04-.64.04-1.6.16-2.76.48-1.16.32-2.56.8-3.96 1.64-.72.4-1.44.92-2.16 1.52-.36.32-.76.64-1 .96l-.24.24c-.08.08-.2.16-.24.28-.2.16-.32.36-.52.56C2.68 7.44 1.6 9.4.96 11.6l-.12.4-.08.44c-.04.28-.12.56-.16.84-.12.6-.16 1.16-.2 1.8 0 .6-.04 1.2.04 1.8.08.6.08 1.2.24 1.84.04.28.12.6.16.92.08.32.2.6.28.92.16.64.44 1.2.68 1.76.12.28.28.56.44.84.16.32.32.56.48.84.2.28.36.56.56.8.2.24.36.52.6.76.44.52.88 1.08 1.32 1.4l.68.64.04.04.04.04.04.04h.08l.2.16.4.28c.16.08.24.2.4.28l.44.24c.32.16.56.36.84.48.56.28 1.16.6 1.76.8.6.28 1.24.4 1.84.6.6.12 1.24.28 1.88.32.64.08 1.24.08 1.88.08.32 0 .64-.04.96-.04l.48-.04.44-.04c1.24-.16 2.44-.52 3.56-.96.32-.12.56-.24.84-.36.28-.12.52-.28.8-.44.52-.28 1.04-.68 1.48-1 .2-.16.4-.36.64-.52l.32-.24.08-.08.04-.04c.04-.04 0 0 0 0v.04l.04-.04.16-.16.6-.6.32-.32.28-.32c.36-.44.72-.88 1-1.32.16-.24.28-.44.44-.68.12-.28.24-.48.36-.72.96-1.96 1.4-3.92 1.48-5.76.08-1.84-.2-3.52-.64-4.92z' />
                </g>
              </g>
            </svg>
          </div>
          <div style={{ paddingTop: '20px', textAlign: 'center', fontSize: '20px', color: 'var(--theme-primary, #9631ff)' }}>רק רגע, העמוד בטעינה...</div>
        </div>
      </div>
    </div>
  );

  async function getNextPage(saleDetails) {
    const idNumber = props._authentication.loginData.userDetails.IDNumber;
    const otpTicketId = '0';
    const otpPhone = '0';

    const customerBanPsidList = saleDetails?.customerBanPsidList;

    const packageType = props.packageType; // none | open | closed

    let isAllowSale = true;

    if (customerBanPsidList != null && customerBanPsidList.length > 0) {
      customerBanPsidList.map((data, index) => {
        if (data.brbType.toUpperCase() == 'T') {
          isAllowSale = false;
        }
        // Check if this BAN is in active status ("O") (not canceled and not suspended)
        if (data.customerStatus.toUpperCase() != 'O') {
          isAllowSale = false;
        }
        // Check if this BAN has a valid payment type for this deal - filter it out.
        if (data.paymentType != 'CC' && data.paymentType != 'DD') {
          isAllowSale = false;
        }
        // Check if this BAN has collection issues - filter it out.
        if (data.collectionInd != 'N') {
          isAllowSale = false;
        }
        // Check if this BAN has a service OTHER than TV or Cellular - filter it out.
        data.listProduct.map((product, i) => {
          if (product.productType != 'T' && product.productType != 'C') {
            isAllowSale = false;
          }
        });
      });
    }

    if (customerBanPsidList == null) {
      isAllowSale = false;
    }

    // אם זיהינו שעל הת.ז שהזין יש מוצר תשתית או אם בחר בלקוח חדש וזיהינו שיש מוצר קיים ללקוח (למרות שבחר בלקוח חדש
    if (isAllowSale == false) {
      props.setError({ isDisplay: true, id: 54, isOpenWorkOrder: true });
      return;
    }

    //------------------ bezeq ------------------
    if (props.infrastructure.tashtitType == 'BF') {
      //no products
      if (props.productsInfo.bezeqFiberProducts.length == 0) {
        props.setError({ isDisplay: true, id: 0, isOpenWorkOrder: false });
        return;
      }

      const selectedProduct = props.productsInfo.selectedProducts[0];
      const equalProduct = props.productsInfo.bezeqFiberProducts.filter((x) => x.downloadSpeed == selectedProduct?.downloadSpeed); //equal product
      const notEqualProducts = props.productsInfo.bezeqFiberProducts.filter((x) => x.downloadSpeed != selectedProduct?.downloadSpeed); //not equal products

      //equal product
      if (equalProduct.length > 0) {
        props.setSelectedInternetPackage(equalProduct[0]); //replace to bezeq product
        props.saveBaseBezeqFiberProduct(equalProduct[0]);
        if (packageType == 'open' && notEqualProducts.length > 0) {
          props.goToPage({ page: 'fiberUpgradesPage', percent: 24 });
        } else {
          props.goToPage({ page: 'technicianPage', percent: 36 });
        }
        return;
      } else {
        props.goToPage({ page: 'bezeqFiberProductsPage', percent: 24 });
        return;
      }
    }
    //------------------ bezeq ------------------

    //לקוח שהגיע לתהליך מבדיקת כתובת, ללא חבילה
    if (packageType == 'none') {
      props.goToPage({ page: 'internetPackagesPage', percent: 24 });
      return;
    }

    //לקוח שיש אצלו תשתית סלקום+ הגיע לתהליך מחבילה פתוחה ואנחנו רוצים להציע לו לשדרג
    if (packageType == 'open') {
      props.goToPage({ page: 'fiberUpgradesPage', percent: 24 });
      return;
    }

    props.goToPage({ page: 'technicianPage', percent: 36 });
  }

  async function getCustomerInfra(idNumber, otpTicketId, flowType, otpPhone) {
    const captchaToken = await getRecaptchaToken('LoginPage');
    if (captchaToken == undefined || captchaToken == null || captchaToken == '') {
      return;
    }

    try {
      const result = await ProviderManager.getProviderData('getCustomerInfra', [idNumber, captchaToken, flowType, otpPhone]);
      console.info('getCustomerInfra', result);
      const isSuccess = result.Header.ReturnCode == 0;
      return isSuccess ? result.Body : null;
    } catch (error) {
      console.info('getCustomerInfra', error);
      return null;
    } finally {
    }
  }
};

const mapStateToProps = (state) => {
  return {
    saleType: state.saleBlock.saleType,
    flowType: state.saleBlock.flowType,
    infrastructure: state.saleBlock.selectedAddress.infrastructure,
    packageType: state.saleBlock.packageType,
    loginTemplate: state.saleBlock.loginTemplate,
    page: state.saleBlock.page,
    productsInfo: state.saleBlock.productsInfo,
    saleDetails: state.saleBlock.saleDetails,

    //other states
    _authentication: state.authentication,
  };
};

const mapDispatchToProps = {
  goToPage,
  setFlowType,
  setSaleDetails,
  reportAnalytics,
  redirectToLogin,
  setLoginData,
  setSelectedInternetPackage,
  saveBaseBezeqFiberProduct,
  setError,
  createOtpForNewCustomerAsync,
  checkUserAsync,

  //loader
  showAppLoader,
  hideAppLoader,
};

export default connect(mapStateToProps, mapDispatchToProps)(LoginPage);
